import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from './../config/app-config';

@Injectable({
  providedIn: 'root'
})

export class FeedDataService {

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  public getData(): Observable<any> {
    console.log("getting data feed");
    const url = this.appConfig.apiUrl + '/FeedData';

    return this.http.get(url);
  }



  //public getDataFeed(): Observable<any> {
  //  const url = this.appConfig.apiUrl + '/FeedData/';

  //  const reqHeaders = this.buildHeaders();

  //  return this.http.get(url, { headers: reqHeaders });
  //}

  //buildHeaders() {
  //  return new HttpHeaders({
  //    "Authorization": "Bearer 123",
  //    "Access-Control-Allow-Origin": "*",
  //    "content-type": "application/json; charset=utf-8"
  //  });
  //}

  //errorHandler(error) {
  //  console.log('service: errorHandler called');
  //  let errorMessage = '';
  //  if (error.error instanceof ErrorEvent) {
  //    // Get client-side error
  //    errorMessage = error.error.message;
  //  } else {
  //    // Get server-side error
  //    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  //  }
  //  console.log('service: error! ' + errorMessage);
  //  return throwError(errorMessage);
  //}

}
